import { all, takeEvery, put, fork, call, select } from 'redux-saga/effects';
import { message } from 'antd';
import actions from './actions';
import { ApiClient } from '../../../api';
import { makeSelectPageToken } from '../../socialPage/selector';
import config from '../../../settings';

// Create selectors once for optimal performance
const selectPageToken = makeSelectPageToken();

function* getPageRolesSaga() {
  yield takeEvery(actions.GET_PAGE_ROLES, function*({ options }) {
    try {
      // Use pageToken for Page Admin operations (page roles management)
      const pageToken = yield select(selectPageToken);
      const apiClient = new ApiClient(config.apiUrl, pageToken);
      const response = yield call(() => apiClient.getPageRoles(options));
      if (response.success) {
        yield put(actions.getPageRolesSuccess(response.data, response.pagination));
      } else {
        yield put(actions.getPageRolesError(response.message || 'Failed to fetch page roles'));
        message.error('Failed to fetch page roles');
      }
    } catch (error) {
      yield put(actions.getPageRolesError(error.message));
      message.error(`Error fetching page roles: ${error.message}`);
    }
  });
}

function* createPageRoleSaga() {
  yield takeEvery(actions.CREATE_PAGE_ROLE, function*({ roleData }) {
    try {
      // Use pageToken for Page Admin operations (page roles management)
      const pageToken = yield select(selectPageToken);
      const apiClient = new ApiClient(config.apiUrl, pageToken);
      const response = yield call(() => apiClient.createPageRole(roleData));
      if (response.success) {
        yield put(actions.createPageRoleSuccess(response.data));
        message.success('Page role created successfully');
      } else {
        yield put(actions.createPageRoleError(response.message || 'Failed to create page role'));
        message.error('Failed to create page role');
      }
    } catch (error) {
      yield put(actions.createPageRoleError(error.message));
      message.error(`Error creating page role: ${error.message}`);
    }
  });
}

function* updatePageRoleSaga() {
  yield takeEvery(actions.UPDATE_PAGE_ROLE, function*({ roleId, roleData }) {
    try {
      // Use pageToken for Page Admin operations (page roles management)
      const pageToken = yield select(selectPageToken);
      const apiClient = new ApiClient(config.apiUrl, pageToken);
      const response = yield call(() => apiClient.updatePageRole(roleId, roleData));
      if (response.success) {
        yield put(actions.updatePageRoleSuccess(response.data));
        message.success('Page role updated successfully');
      } else {
        yield put(actions.updatePageRoleError(response.message || 'Failed to update page role'));
        message.error('Failed to update page role');
      }
    } catch (error) {
      yield put(actions.updatePageRoleError(error.message));
      message.error(`Error updating page role: ${error.message}`);
    }
  });
}

function* deletePageRoleSaga() {
  yield takeEvery(actions.DELETE_PAGE_ROLE, function*({ roleId }) {
    try {
      // Use pageToken for Page Admin operations (page roles management)
      const pageToken = yield select(selectPageToken);
      const apiClient = new ApiClient(config.apiUrl, pageToken);
      const response = yield call(() => apiClient.deletePageRole(roleId));
      if (response.success) {
        yield put(actions.deletePageRoleSuccess(roleId));
        message.success('Page role deleted successfully');
      } else {
        yield put(actions.deletePageRoleError(response.message || 'Failed to delete page role'));
        message.error('Failed to delete page role');
      }
    } catch (error) {
      yield put(actions.deletePageRoleError(error.message));
      message.error(`Error deleting page role: ${error.message}`);
    }
  });
}

export default function* pageRolesSaga() {
  yield all([
    fork(getPageRolesSaga),
    fork(createPageRoleSaga),
    fork(updatePageRoleSaga),
    fork(deletePageRoleSaga),
  ]);
}
